export default "__VITE_ASSET__nRhxW6mS__"